// extracted by mini-css-extract-plugin
export var connectionButton = "_bp-1";
export var rightPanel = "_bp-3";
export var stepDescription = "_bp-2";
export var stepIcon = "_bp-0";